import type { PatientId } from "./types";

interface NameableEvent {
  title: string;
  patient: { id: PatientId; firstName: string; lastName: string };
}

/**
 * What a cell shows in place of a patient's name while privacy mode is on — the old
 * grid's rule, from `appointment-cell.component.tsx:171-176`.
 *
 * A row with no patient keeps its own title: a Google Calendar import's summary is not a
 * person's name, and blanking it would leave an unidentifiable card rather than a private
 * one.
 */
export function privateName(event: NameableEvent): string {
  const { firstName, lastName, id } = event.patient;
  if (!id || (!firstName && !lastName)) return event.title;
  return [firstName?.[0] ?? "", lastName?.[0] ?? ""].join(" ").trim();
}

/**
 * A title's initials, one per word: "Ada King Lovelace" is "A K L". Privacy mode's mask for
 * a name that has no loaded booking to read a patient from (a Radar row whose appointment is
 * off the grid's range, the label Rebook hands to Find Next).
 */
export function titleInitials(title: string): string {
  return title
    .split(/\s+/)
    .filter(Boolean)
    .map((word) => word[0])
    .join(" ");
}
